export default __webpack_public_path__ + "resources/icons/d440-ce51.webp";